const axios = require('axios');
const apiUrl = '/wp-json/wp/v2/';

let app,
    blog;

const setVariables = async () => {
  blog = document.getElementById('blog');
}

//asynchroniczny forEach ;)
async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

class State {
  constructor() {
    this._page = 1;
    this._perPage = 6;
    this._cheacker = true;
    this._offset = 5;
  }

  setPage(page) {
    this._page = page;
  }
  getPage() {
    return this._page;
  }

  setPerPage(perPage) {
    this._perPage = perPage;
  }
  getPerPage() {
    return this._perPage;
  }

  setCheacker(cheacker) {
    this._cheacker = cheacker;
  }
  getCheacker() {
    return this._cheacker;
  }

  setOffset(offset) {
    this._offset = offset;
  }
  getOffset() {
    return this._offset;
  }
}


const resetState = () => {
  app.setPage(1);
  app.setCheacker(true);
  clearBlog();
}

const clearBlog = async () => {
  blog.innerHTML = '';
}


const createPostCard = async (post) => {
  console.log(post)
  let thumbnail;
  if(post.post_thumbnail) {
    thumbnail = post.post_thumbnail[0];

  } else {
    thumbnail = '/wp-content/uploads/2020/04/2019_04_INMONDO_POKÓJ_DZIEWCZYNKI_5-13483.jpg';
  }
  
  const generate = async () => {
    const box = await document.createElement('div');
    await box.classList.add('blogPost__box');
  
    const imageBox = await document.createElement('div');
    await imageBox.classList.add('blogPost__image');
    imageBox.style.backgroundColor = await post.acf.post_color;

    const imageBoxUrl = await document.createElement('a');
    imageBoxUrl.href = await post.link;

    const imageBoxInner = await document.createElement('div');
    await imageBoxInner.classList.add('blogPost__imageInner');
    imageBoxInner.style.backgroundImage = await 'url(' + thumbnail + ')';


    const textBox = await document.createElement('div');
    await textBox.classList.add('blogPost__textBox');

    const boxCategory = await document.createElement('p');
    boxCategory.innerText = await post.post_categories[0].name;
    boxCategory.className = "blogPost__category"
    // boxCategory.href = await post.post_categories[0].link;

    boxCategory.style.color = await post.acf.post_color;

  
    const boxHeader = await document.createElement('h2');
    boxHeader.innerText = await post.title.rendered;
  
    const boxHeaderLink = await document.createElement('a');
    boxHeaderLink.href = await post.link;
    await boxHeaderLink.appendChild(boxHeader);
  
    const boxPermalink = await document.createElement('div');
    await boxPermalink.classList.add('blogPost__button');
  
    const boxButton = await document.createElement('a');
    boxButton.className = 'blogPost__permalink link link--arrow';
    boxButton.href = await post.link;
    boxButton.innerText = await "Czytaj dalej";
  
    await boxPermalink.appendChild(boxButton);
    await imageBoxUrl.appendChild(imageBoxInner);
    await imageBox.appendChild(imageBoxUrl);
    await box.appendChild(imageBox);
    await textBox.appendChild(boxCategory);
    await textBox.appendChild(boxHeaderLink);
    await textBox.appendChild(boxPermalink);
    await box.appendChild(textBox);
    await blog.appendChild(box);
  }

  await generate();
  
};

const getPosts = () => {
  if (app.getCheacker() == true) {
    axios.get(apiUrl + 'posts', {
        params: {
          per_page: app.getPerPage(),
          page: app.getPage(),
          offset: app.getOffset()
        }
      })
      .then((response) => {

        if (response.data.length > 0) {
          let page = app.getPage();
          let offset = app.getOffset();
          page += 1;
          offset += 6;
          app.setPage(page);
          app.setOffset(offset);

          if (response.headers['x-wp-totalpages'] < page) {
            app.setCheacker(false);
            document.querySelector('.showMore').style.visibility = "hidden";
          } else {
            document.querySelector('.showMore').style.visibility = "visible";
          }

          asyncForEach(response.data, async post => {
            await createPostCard(post);
          });
        } else {
          app.setCheacker(false);
          document.querySelector('.showMore').style.visibility = "hidden";

          const blog = document.getElementById('blog');
          const errorHeader = document.createElement('h3');
          errorHeader.innerText = "Brak postów do wyświetlenia";
          blog.appendChild(errorHeader)
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  } else {

  }
}

const getInitPosts = () => {

  if (app.getCheacker() == true) {

    axios.get(apiUrl + 'posts', {
        params: {
          per_page: 5,
          page: 1,
        }
      })
      .then((response) => {
        console.log(response);
        if (response.data.length > 0) {
          let page = app.getPage();
          page += 1;
          app.setPage(page);
          if (response.headers['x-wp-totalpages'] < page) {
            app.setCheacker(false);
            document.querySelector('.showMore').style.visibility = "hidden";
          } else {
            document.querySelector('.showMore').style.visibility = "visible";
          }

          asyncForEach(response.data, async post => {
            await createPostCard(post);
          });
        } else {
          app.setCheacker(false);
          document.querySelector('.showMore').style.visibility = "hidden";

          const blog = document.getElementById('blog');
          const errorHeader = document.createElement('h3');
          errorHeader.innerText = "brak postów";
          blog.appendChild(errorHeader)
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  } else {

  }
}

const eventsRun = () => {
  const seeMore = document.getElementById('seeMore');
  const link = document.createElement('a');
  var linkText = document.createTextNode('załaduj więcej');
  link.appendChild(linkText);
  link.classList.add('showMore', 'button', "button--arrow", "button--arrow--down");
  seeMore.appendChild(link);
  const handler = seeMore.querySelector('a');

  handler.addEventListener('click', () => {
    getPosts();
  });
}

export const blogInit = async () => { 
  await setVariables();
  app = new State();
  await getInitPosts();
  await eventsRun();
}